<template>
  <div id="body">
    <div class="title">
      <i class="el-icon-s-finance"> </i> 我的钱包
    </div>

<!--    <div id="top">-->
<!--      <div class="itemA">-->
<!--        车信报告 <br>-->
<!--        <span class="itemAfont">{{ second }}</span>次-->
<!--      </div>-->
<!--      <div class="itemA">-->
<!--        维保报告 <br>-->
<!--        <span class="itemAfont">{{ maintenanceSecond }}</span>次-->
<!--      </div>-->
<!--      <div class="itemA">-->
<!--        现金余额(元) <br>-->
<!--        ￥ <span>{{ balance }}</span>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div style="background-color: #004085; width: 100%;padding-bottom: 2%; padding-top: 2%">-->
<!--      <div style="text-align: right; color: #FFFFFF; margin-right: 3%;">{{ member }}</div>-->
<!--    </div>-->

<!--    <div id="top-item">-->
<!--      <div class="item" id="item-border">-->
<!--        <div class="money">￥ {{ balance }}</div>-->
<!--        <span>现金余额(元)</span>-->
<!--      </div>-->
<!--      <div class="item">-->
<!--        <div style="color: #FFFFFF; margin-top: 5%;">{{ backTime }}</div>-->
<!--        <span>变更时间</span>-->
<!--      </div>-->
<!--    </div>-->

    <div class="itemA">
      车信报告 <br>
      <span class="itemAfont">{{ second }}</span>次
    </div>
    <div class="itemA" style="margin-top: 1%">
      维保报告 <br>
      <span class="itemAfont">{{ maintenanceSecond }}</span>次
    </div>
    <div class="itemA" style="margin-top: 1%">
      现金余额(元) <br>
      ￥<span class="itemAfont">{{ balance }}</span>
      <span style="float: right; padding-right: 5%">{{ member }}</span>
    </div>


    <el-button type="primary" @click="isShow()" v-show="!showBtn" class="btn btn-primary" style="margin-top: 3%;">
      查询明细</el-button>
    <el-button type="primary" @click="noShow()" v-show="showBtn" class="btn btn-primary"
               style="margin: 0 auto; margin-top: 3%;">隐藏明细</el-button>

    <div>
      <div class="block" style="margin-top: 20px;">
        <div style="margin-left: 8%; color: #0C0C0C" @click.p="sortFunction">
<!--              <el-button type="primary" @click="desc()">主要按钮</el-button>
              <el-button type="success" @click="ace()">成功按钮</el-button>-->

          <el-radio v-model="radio" label="0"><span style="color: #000000;">最新时间</span></el-radio>
          <el-radio v-model="radio" label="1"><span style="color: #000000;">最早时间</span></el-radio>

<!--              <div style="margin-left: 10%; width: 50%;" @click="sortFunction">
                <el-radio :label="0"  v-model="radio">
                  <span style="color: #000000;">最新时间</span>
                </el-radio>
              </div>
              <div style="margin-left: 10%; width: 50%;" @click="sortFunction">
                <el-radio :label="1"  v-model="radio">
                  <span style="color: #000000;">最早时间</span>
                </el-radio>
              </div>-->
        </div>


        <el-timeline style="margin-top: 20px;"
                     v-infinite-scroll="load"
                     :infinite-scroll-immediate="false"
                     :infinite-scroll-disabled="disabled">
          <el-timeline-item color="#909399" v-for="(walletLog, index) in walletLogs" :key="index"
                            :timestamp="walletLog.time">
            <div v-if="walletLog.type == 0">
              充值{{walletLog.second}}次,车信剩余{{walletLog.total}}次,维保剩余{{walletLog.maintenanceSecond}}次,余额{{walletLog.recharge}}元
            </div>
            <div v-if="walletLog.type == 1">
              {{walletLog.realName}}消费{{walletLog.second}}次,车信剩余{{walletLog.total}}次,维保剩余{{walletLog.maintenanceSecond}}次
            </div>
            <div v-if="walletLog.type == 2">
              扣费{{walletLog.second}}次,扣费{{walletLog.recharge}}元,车信剩余{{walletLog.total}}次,维保剩余{{walletLog.maintenanceSecond}}次
            </div>
            <div v-if="walletLog.type == 3">
              转入{{walletLog.second}}次,车信剩余{{walletLog.total}}次,维保剩余{{walletLog.maintenanceSecond}}次,余额{{walletLog.recharge}}元
            </div>
            <div v-if="walletLog.type == 4">
              转出{{walletLog.second}}次,车信剩余{{walletLog.total}}次,维保剩余{{walletLog.maintenanceSecond}}次,余额{{walletLog.recharge}}元
            </div>
          </el-timeline-item>
        </el-timeline>

        <div>
          <p v-if="loading" style="background-color: #f5f5f5; margin-top: 10px; text-align: center;">
            <i class="el-icon-loading"></i>加载中...
          </p>
          <p v-if="noMore" style="background-color: #f5f5f5; margin-top: 15px; text-align: center;">
            <i class="el-icon-bell"></i> 没有更多记录了
          </p>
        </div>

<!--        <el-empty description="暂无记录" id="item" v-if="isNull"></el-empty>-->
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      radio: "0",
      details: 1,
      sort: 0,
      showBtn: true,
      lastTime: 0,
      aceOrDesc:true,
      openId: '',
      isNull: true,
      balance: '0',
      second: '0',
      backTime: '',
      reverse: true,
      walletLogs: [],
      cmpId: '',
      member: '会员等级',

      page: 0, //起始页数
      loading: false,
      total: "", //总页数
      limit: 18,
      maintenanceSecond: '0',
      disabledGet: true,
      noMore: false
    };
  },
  computed: {
    disabled() {
      return this.loading
    },
  },
  methods: {
    load() {
      setTimeout(() => {
        if(this.disabledGet){
          this.disabledGet = false
          this.loading = true
          this.page += this.limit
          this.getMoInfoLog()
        }
      }, 1500)
    },
    getMoInfo() {
      this.$api({
        method: 'post',
        url: '/mobileLogin/getMoInfo/' + this.openId,
      }).then((res) => {
        //alert(JSON.stringify(res.data))
        if (res.data.code == 200) {
          this.second = res.data.data.second
          this.maintenanceSecond = res.data.data.maintenanceSecond
          this.balance = res.data.data.balance
        }
      })
    },
     getMoInfoLog() {
        this.$api({
          method: 'post',
          url: '/mobileLogin/getMoLogInfo/' + this.cmpId + '?details=' + this.details + '&page=' + Number(this.page) + '&size=' + Number(this.limit) + '&sort=' + this.sort,
        }).then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.walletLogs = this.walletLogs.concat(res.data.data);
              this.walletLogs.length > 0 == true ? this.isNull = false : this.isNull = true

              if(res.data.data.length==this.limit){
                this.loading = false
                this.disabledGet = true
              }
              if(res.data.data.length<this.limit){
                this.loading = false
                this.noMore = true
              }
            }, 500)

          } else {
            alert("请求失败")
          }
        })
    },

    getCompanyId() {
      this.$api({
        methods: 'get',
        url: '/mobileLogin/getInfoByOpenId?openId=' + this.openId
      }).then((res) => {
        this.cmpId = res.data.companyId

        this.getMoInfoLog()

        this.member = res.data.member
        if (this.member == 0) {
          this.member = '普通会员'
        } else if (this.member == 1) {
          this.member = '银卡会员'
        } else if (this.member == 2) {
          this.member = '金牌会员'
        } else if (this.member == 3) {
          this.member = '白金会员'
        } else if (this.member == 4) {
          this.member = '包月会员'
        }
      })
    },
    sortFunction(){
      //获取当前时间的时间戳
      let now = new Date().valueOf();
      //第一次点击
      if(this.lastTime == 0){
        if(this.radio == 1){
          this.sort = 0
          this.page = 0
          this.walletLogs = []
          this.getMoInfoLog()
        }else{
          this.sort = 1
          this.page = 0
          this.walletLogs = []
          this.getMoInfoLog()
        }
        this.lastTime = now;
      }else{
        if((now-this.lastTime) > 500){
          //重置上一次点击时间，2000是我自己设置的2秒间隔，根据自己的需要更改
          this.lastTime = now;
          if(this.radio == 1){
            this.sort = 0
            this.page = 0
            this.walletLogs = []
            this.getMoInfoLog()
          }else{
            this.sort = 1
            this.page = 0
            this.walletLogs = []
            this.getMoInfoLog()
          }
        }else{

        }
      }

    },
    isShow() {
      this.page = 0
      this.walletLogs = []
      this.showBtn = true
      this.details = 1
      this.getMoInfoLog()
    },
    noShow() {
      this.page = 0
      this.walletLogs = []
      this.showBtn = false
      this.details = 0
      this.getMoInfoLog()
    }
  },
  created() {

    if (this.$route.query.openid != null && this.$route.query.openid != '') {
      this.$store.state.openId = this.$route.query.openid
      this.openId = this.$route.query.openid
      localStorage.setItem("status", this.$route.query.status)
      localStorage.setItem('openId', this.$route.query.openid)
    } else {
      this.openId = localStorage.getItem('openId')
    }
    this.getCompanyId()
    this.getMoInfo()
  },
};
</script>

<style>
.itemAfont{
  font-size: 28px;
}
.itemA{
  margin: 0 auto;
  padding-top: 2%;
  height: 80px;
  padding-left: 5%;
  width: 95%;
  color: #ffffff;
  border-radius: 5px 5px 5px 5px;
  background-color: #004085;
}
#top {
  margin-top: -17%;
  background-color: #004085;
  width: 100%;
  height: 10.75rem;
  padding-top: 15%;
}

#top-item {
  background-color: #0056B3;
  width: 100%;
  height: 5.25rem;
  margin: 0 auto;
  display: flex;
  /*重要*/
  /*横向排列*/
  align-items: center;
  /*重要*/
  /*子类居中*/
  padding-top: 5%;
}

.item {
  width: 50%;
  margin-bottom: 5%;
  text-align: center;
}

.money {
  color: #FFFFFF;
  border-radius: 10%;
  font-size: 1.25rem;
}

#coutMoney {
  font-size: 1.575rem;
}

span {
  color: #FFFFFF;
}

#item-border {
  border-right: 0.0625rem solid #FFFFFF;
}

.btn {
  margin-top: 0.5rem;
  width: 80%;
  margin-left: 10%;
}

#bottom {
  color: #B3B7BB;
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 35px;
  /*脚部的高度*/
  clear: both;
}

.register {
  width: 100%;
  margin-bottom: 20px;
}
</style>
